import { createFileRoute } from "@tanstack/react-router";
import { CapturesPage } from "@/features/settings/captures-page";

export const Route = createFileRoute("/_app/settings/downstreams/$id")({
  component: CapturesPage,
});
